import { gql } from "@apollo/client";

export const GET_ALL_ZONES = gql`
  query GetAllZones($buildingId: uuid) {
    Zone(where: { buildingId: { _eq: $buildingId }, isActive: { _eq: true } }) {
      buildingId
      created_at
      id
      isActive
      isRadius
      name
      points
      radius
      updated_at
    }
  }
`;

export const INSERT_GEOFENCE = gql`
  mutation InsertGeoFence(
    $buildingId: uuid
    $name: String
    $zones: Zone_arr_rel_insert_input = { data: {} }
    $roleGeoFences: RoleGeoFence_arr_rel_insert_input = { data: {} }
  ) {
    insert_GeoFence(
      objects: {
        buildingId: $buildingId
        isActive: true
        name: $name
        Zones: $zones
        RoleGeoFences: $roleGeoFences
      }
    ) {
      affected_rows
    }
  }
`;

export const GET_GEOFENCES = gql`
  query GetGeoFences($limit: Int = 10, $offset: Int, $buildingId: uuid) {
    GeoFence(
      limit: $limit
      offset: $offset
      where: {
        buildingId: { _eq: $buildingId }
        _and: { isActive: { _eq: true } }
      }
    ) {
      buildingId
      created_at
      id
      isActive
      name
      updated_at
    }
    GeoFence_aggregate {
      aggregate {
        count
      }
    }
  }
`;
